/** What each enterprise audit-log action reads as on the 操作记录 tab; unknown codes show as is. */
export const auditLabels = {
    ATTACHMENT_ADDED: '上传订单附件',
    COUNTERPARTY_CREATED: '新增往来单位',
    COUNTERPARTY_MERGED: '合并往来单位',
    COUNTERPARTY_UPDATED: '修改往来单位',
    DISCREPANCY_CONFIRMED: '处理收货差异',
    DRIVER_CREATED: '新增司机',
    DRIVER_UPDATED: '修改司机',
    LOCAL_ORDER_CREATED: '登记单据',
    LOCAL_ORDER_POSTED: '登记出入库',
    LOCAL_ORDER_RECONCILED: '单据对账',
    LOCAL_PAYMENT_RECORDED: '登记收付款',
    LOCAL_PAYMENT_VOIDED: '作废收付款',
    LOCAL_STATEMENT_ISSUED: '出具对账单',
    LOCAL_STATEMENT_LINK_CREATED: '发送对账单确认链接',
    LOCAL_STATEMENT_PAYMENT: '对账单收付款',
    LOCAL_STATEMENT_PAYMENT_VOIDED: '作废对账单收付款',
    LOCAL_STATEMENT_WITHDRAWN: '撤回对账单',
    MAPPING_SAVED: '设置商品对应关系',
    MATERIAL_SETTINGS_CHANGED: '修改原料联动设置',
    MEMBER_CREATED: '新增成员',
    MEMBER_PASSWORD_LINK: '生成设置密码链接',
    MEMBER_ROLES_CHANGED: '修改成员岗位',
    MEMBER_WECHAT_RESET: '重置成员微信绑定',
    ORDER_CANCELLED: '取消订单',
    ORDER_CONFIRMED: '确认订单',
    ORDER_CREATED: '新建订单',
    ORDER_INVITE_CREATED: '发送客户签收链接',
    ORDER_INVITE_REVOKED: '撤回客户签收链接',
    ORDER_REVISED: '变更订单约定',
    PARTNER_ACCEPTED: '同意合作邀请',
    PARTNER_INVITED: '邀请合作企业',
    PAYMENT_CLAIMED: '提交付款',
    PAYMENT_CONFIRMED: '确认收款',
    PAYMENT_PROFILE_SAVED: '修改收款信息',
    PAYMENT_QR_SAVED: '修改收款码',
    PAYMENT_RECORDED: '登记收款',
    PAYMENT_REJECTED: '退回付款',
    PRODUCTION_POSTED: '生产入库',
    RECEIPT_POSTED: '登记收货',
    RETURN_REQUESTED: '申请退货',
    RETURN_APPROVE: '同意退货',
    RETURN_REJECT: '驳回退货',
    RETURN_SHIP: '退货发出',
    RETURN_RECEIVE: '退货收回',
    SALES_PRICE_CHANGED: '修改销售报价',
    SETTLEMENT_CONFIRMED: '确认对账',
    SETTLEMENT_PROPOSED: '发起对账',
    SHIPMENT_POSTED: '登记发货',
    SKU_CATEGORY_CHANGED: '修改商品分类',
    SKU_CATEGORY_CREATED: '新增商品分类',
    SKU_CATEGORY_DELETED: '删除商品分类',
    SKU_CREATED: '新增商品',
    SKU_MAPPING_AUTO: '自动对应商品',
    SKU_UPDATED: '修改商品',
    SKU_USAGE_CHANGED: '修改商品用途',
    STATEMENT_CONFIRMED: '确认对账单',
    STATEMENT_ISSUED: '出具对账单',
    STATEMENT_PAYMENT_CLAIMED: '对账单提交付款',
    STATEMENT_PAYMENT_CONFIRMED: '对账单确认收款',
    STATEMENT_PAYMENT_RECORDED: '对账单登记收款',
    STATEMENT_PAYMENT_REJECTED: '对账单退回付款',
    STATEMENT_REJECTED: '对账单有异议',
    STATEMENT_WITHDRAWN: '撤回对账单',
    STOCK_ADJUSTED: '库存调整',
    STOCK_RESERVED: '库存占用',
    WAREHOUSE_CREATED: '新增仓库',
};
